// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"fab4b6b1","74":"d3be7365","168":"63bde89c","234":"5985a4de","435":"780c0b82","498":"65187169","557":"ed7d2311","591":"a054e3f3","632":"f55b5648","788":"b61adb7f","845":"e9c470c3"}[chunkId] + ".chunk.js";
};